document.querySelectorAll('.widget-menu__headline').forEach((headline) => {
  headline.addEventListener('click', () => {
    headline.nextElementSibling.style.height = headline.nextElementSibling.scrollHeight + 'px';
    headline.parentElement.classList.toggle('widget-menu__group--visible');
  });
});